import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

function Product() {
  const [data, setData] = useState([]);
  const [filter, setfilter] = useState(data);
  const [loading, setLoading] = useState(false);

  let componentMounted = true;

  useEffect(() => {
    const getProducts = async () => {
      setLoading(true);
      const response = await fetch("https://fakestoreapi.com/products");
      if (componentMounted) {
        setData(await response.clone().json());
        setfilter(await response.json());
        setLoading(false);
        console.log(filter);
      }

      return () => {
        componentMounted(false);
      };
    };

    getProducts();
  }, []);

  const Loading = () => {
    return (
        <>
        loading....
       
        </>
        );
  };

  const filterProduct =(cat)=>{
    const updatedList = data.filter((x)=>x.category===cat)
    setfilter(updatedList)

  }

  const ShowProducts = () => {
    return (
      <>
        <div className="buttons d-flex justify-content-center mb-5 pb-5">
          <button className="btn btn-outline-dark me-2" onClick={()=>setfilter(data)}>All</button>
          <button className="btn btn-outline-dark me-2" onClick={()=>filterProduct("men's clothing")}>Garments</button>
          <button className="btn btn-outline-dark me-2" onClick={()=>filterProduct("electronics")}>Electronic</button>
        </div>
        {filter.map((product)=>{
            return(
                <>
                <div className="col-md-3 mb-4">
                    <div class="card h-100 text-center p-4" key={product.id} >
                      <img src={product.image} class="card-img-top" alt={product.title} height="250px"/>
                       <div class="card-body">
                        <h5 class="card-title mb-0">{product.title.substring(0,12)}</h5>
                           <p class="card-text lead fw-bold">
                           Price = $ {product.price}
                           </p>
                           <NavLink to={`/product/${product.id}`} ><button className="btn btn-outline-dark">Buy Now</button></NavLink>
                       </div>
                    </div>



                
                </div>
                </>
            )
        })}
      </>
        
    );
  };

  return (
    <>
      <div className="container my-5 py-5">
        <div className="row">
          <div className="col-12 mb-5">
            <h1 className="display-6 fw-bolder text-center">Latest Products</h1>
            <hr />
          </div>
        </div>
        <div className="row justify-content-center">
          {loading ? <Loading /> : <ShowProducts />}
        </div>
      </div>
    </>
  );
}

export default Product;
